import { useCallback, useState } from "react";
import { PlayersService } from "../../../../../core/http/services/PlayersService";

const normalizePlayers = (data) => {
  if (Array.isArray(data)) return data;
  return data?.data ?? data?.players ?? data?.items ?? [];
};

const normalizePagination = (data) => ({
  total: data?.total ?? 0,
  page: data?.page ?? 1,
  totalPages: data?.totalPages ?? 1,
});

const usePlayers = () => {
  const [players, setPlayers] = useState([]);
  const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 20 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ type: null, message: null });

  const fetchPlayers = useCallback(async ({ page = 1, limit = 20, ...params } = {}) => {
    setLoading(true);
    setError({ type: null, message: null });

    const { status, data, message } = await PlayersService.getAll({ page, limit, ...params });

    if (status !== 200) {
      setError({ type: "players", message });
      setLoading(false);
      return;
    }

    setPlayers(normalizePlayers(data));
    setPagination(normalizePagination(data));
    setLoading(false);
  }, []);

  return {
    players,
    setPlayers,
    pagination,
    loading,
    error,
    fetchPlayers,
  };
};

export default usePlayers;
